module.exports = __webpack_public_path__ + "img/icon-toggle-check-box.50a66b44.svg";